import React from "react"

import SimplePage from "layouts/SimplePage"

import "./Legal.sass"

const Legal = () => {
  return (
    <>
      <SimplePage className="Legal" isTinted>
        <h1>Pravno obvestilo</h1>
        <h2>PRAVICE INTELEKTUALNE LASTNINE</h2>
        <p>
          Vsebine, objavljene na spletnem naslovu{" "}
          <a href="https://avtolog.si">https://avtolog.si</a> (v nadaljevanju:
          spletno mesto) so last AMZS d.d. in so, v zakonsko dovoljenem okviru,
          predmet avtorske zaščite ali druge oblike zaščite intelektualne
          lastnine.
        </p>

        <h2>OMEJENA PRAVICA UPORABE VSEBIN</h2>
        <p>
          Uporabnik lahko uporablja vsebine na spletni strani izključno za svojo
          osebno, to je nekomercialno rabo, pri čemer ne sme spreminjati o
          avtorskih ali drugih pravicah. Vsaka druga oblika uporabe vsebin
          spletnga mesta, kot je npr. kopiranje, reproduciranje, distribuiranje
          ter ostale oblike izkoriščanja avtorskega dela v komercialne namene
          brez pisnega dovoljenja AMZS d.d., je prepovedana. AMZS d.d. ne
          odgovarja za obliko in vsebino spletnih strani, ki so na kakršenkoli
          način povezane s spletnim mestom{" "}
          <a href="https://avtolog.si">https://avtolog.si</a>. Pri obisku in
          uporabi povezanih spletnih strani je odgovornost AMZS d.d. za vse
          primere izključena.
        </p>

        <h3>OMEJITEV ODGOVORNOSTI</h3>
        <p>
          AMZS d.d. se bo trudila, da bodo podatki na spletnem mestu točni in
          ažurni, vendar AMZS d.d. ne more biti odgovorna za morebitno škodo, ki
          bi uporabniku lahko nastala zaradi uporabe spletnega mesta ali
          nemožnosti uporabe le-tega. AMZS d.d. lahko vse vsebino spreminja
          kadarkoli, brez obveznosti do obveščanja uporabnikov, in ne odgovarja
          za posledice tako povzročenih sprememb.
        </p>

        <h3>VARSTVO OSEBNIH PODATKOV</h3>
        <p>
          AMZS d.d. se zavezuje, da bo varovala zaupnost osebnih podatkov
          uporabnikov, zbranih prek spletnega mesta{" "}
          <a href="https://avtolog.si">https://avtolog.si</a> v skladu s
          predpisi, ki urejajo varstvo osebnih podatkov. Za podrobnosti glede
          obdelovanja vaših osebnih podatkov si oglejte Informacije o obdelavi
          osebnih podatkov.
        </p>
      </SimplePage>
    </>
  )
}

export default Legal
